const CreateEventModalHOC = props => {
    return props.children;
}

export default CreateEventModalHOC;
